import React from 'react'
import { SelectFilter } from '../search/SelectFilter'
import { LeftSearchMenuPiece } from '../search/LeftSearchMenuPiece'
import { getContactByCriteria } from '../services/search.service';
import { FILTER_VARIANTS, FILTER_TITLES, FILTER_ID } from '../utils/surveyLiterals';

export const DeereContactFilter = ({ setDeereContactSelected, abortControllerRef }) => {

    const handleDeereContactSelection = event => {
        if (event)
            setDeereContactSelected(event.value)
        else
            setDeereContactSelected(null)
    }

    return (
        <LeftSearchMenuPiece>
            <LeftSearchMenuPiece.Item id={FILTER_ID.DEERECONTACT} title={FILTER_TITLES.DEERECONTACT}>
                <SelectFilter loadOptionsFunction={getContactByCriteria} onChange={handleDeereContactSelection} variant={FILTER_VARIANTS.DEERECONTACT} abortControllerRef={abortControllerRef}/>
            </LeftSearchMenuPiece.Item>
        </LeftSearchMenuPiece>
    )
}